module.exports = __webpack_public_path__ + "bd88df40ec7975b306770d345e34dcf4.png";